const successIcon = require("./successIcon");
const createHTMLElement = require("../dom/createHTMLElement");
const appendToComponent = require("../dom/appendToComponent");

/**
 * @param message {string}
 * @return {HTMLElement}
 */
module.exports = function successDialog(message) {
    const successIcon$ = successIcon();

    const successDialog$ = createHTMLElement(`
        <dialog class="dialog">
            <div style="display: flex; flex-direction: column; gap: 1rem; text-align: center;">
                <div data-component="successIcon"></div>
                <div data-component="successMessage">${message}</div>
            </div>
        </dialog>
    `);

    appendToComponent(successDialog$, "successIcon", successIcon$);

    return successDialog$;
}